import * as Yup from "yup";
/* eslint-disable no-useless-escape */
const ChangeProfileValidation = (t) => {
  return Yup.object().shape({
    given_name: Yup.string()
      .min(2, t("auth.givenName.validMessage"))
      .required(t("auth.givenName.validMessage")),
    family_name: Yup.string()
      .min(2, t("auth.familyName.validMessage"))
      .required(t("auth.familyName.validMessage")),
  });
};
export default ChangeProfileValidation;
